export default __webpack_public_path__ + "static/media/coding.2dc34f3f.svg";